import HeaderSubSection from "../../components/HeaderSubSection/index.vue";
import articlesFilterSection from "../../components/articlesFilterSection/index.vue";
import articlesByFiltresSection from "../../components/articlesByFiltresSection/index.vue";

export default {
  name: "articlesByFiltrePage",
  components: {
    HeaderSubSection,
    articlesFilterSection,
    articlesByFiltresSection,
  },
};
